<template>
  <div class="report-dialog-page" ref="reportDialogPage" v-if="showReport">
    <div class="content" ref="mainReport">
      <div class="action-panel">
        <div class="item-action" @click="doReport">Report</div>
        <div class="item-action" @click="doBlock" v-if="type==1">Block</div>
      </div>
      <div class="cancel-action" @click="hideDialog">Cancel</div>
    </div>
    <ReportContentDialog :acc="acc" :show-report-content="showReportContentFlag"
                         @hideReportContent="hideReportContent"></ReportContentDialog>
  </div>
</template>

<script>
  import {isnull, Toast} from "../../utils/tools";
  import ReportContentDialog from './reportcontentdialog'
  import AccountApi from '../../api/account-api'
  import LiveAPi from '../../api/live-api'
  import VoiceAPi from '../../api/voice-api'
  import {loge} from "../../utils/devext";
  import StatisticsHelper from "../../utils/StatisticsUtils";
  import EventBusConstant from "../../push/const/EventBusConstant";
  import TipsUtils from "../../utils/TipsUtils";
  import BlackUtils from "../../utils/BlackUtils";

  export default {
    name: "reportdialog",
    props: {
      'acc': {
        default: 0
      },
      'type': {
        default: 0
      },
      'room': {
        default: -1
      },
      sucCallback: {
        type: Object,
        default: null
      },
      'showReport': {
        type: Boolean,
        default: false
      }
    },
    components: {
      ReportContentDialog: ReportContentDialog
    },
    data() {
      return {
        showReportContentFlag: false
      }
    },
    methods: {
      hideReportContent() {
        this.showReportContentFlag = false
      },
      showReportContent() {
        this.showReportContentFlag = true
      },
      bodyCloseReportDialog(e) {
        let self = this;
        if (this.$refs.mainReport && !this.$refs.mainReport.contains(e.target)) {
          self.hideDialog();
        }
      },
      hideDialog() {
        StatisticsHelper.user_action()
        this.$emit("hideReport");
        this.$EventBus.$emit(EventBusConstant.EVENT_REPORT_BLOCK_HIDE)
      },
      doReport() {
        StatisticsHelper.user_action()
        // this.showReportContent()
        let data = {
          content: 'report from webapp in halo live',
          images: []
        }
        if ((isnull(this.acc) && this.type == 1) || (this.type != 1 && isnull(this.room))) {
          Toast.error('Server error',this)
          return;
        }
        if (this.type == 1) {
          AccountApi.report(this.acc, data, function (data, page) {
            page.notifyRes(0)
          }, function (code, msg, page) {
            page.notifyRes(code, msg)
          }, this)
        } else if (this.type == 2) {
          VoiceAPi.reportRoom(this.room, data, function (data, page) {
            page.notifyRes(0)
          }, function (code, msg, page) {
            page.notifyRes(code, msg)
          }, this)
        } else if (this.type == 3) {
          LiveAPi.reportRoom(this.room, data, function (data, page) {
            page.notifyRes(0)
          }, function (code, msg, page) {
            page.notifyRes(code, msg)
          }, this)
        }
        this.hideDialog()

      },
      notifyRes(code, msg = '') {
        this.hideDialog()
        if (code == 0) {
          Toast.info('Reported successfully', this)
          this.sucCallback && this.sucCallback()
        } else {
          Toast.error(TipsUtils.getErrorTips(code), page)
          Toast.info('Reported failed', this)
        }
      },
      doBlock() {
        if (isnull(this.acc)) {
          return
        }
        let parent = this
        AccountApi.block(this.acc, function (data, page) {
          Toast.info('Blocked successfully', page)
          parent.hideDialog()
          BlackUtils.refreshList(page)

        }, function (code, msg, page) {
          Toast.error('Blocked failed', page)
          loge('doBlock', 'doBlock failed;' + msg)
        }, this)

      }

    },
    watch: {
      showReport(n, o) {
        if (n) {
          let target = this
          setTimeout(function () {
            target.$refs.reportDialogPage.addEventListener("click", target.bodyCloseReportDialog);
          }, 100)

        } else {
          this.$refs.reportDialogPage.removeEventListener("click", this.bodyCloseReportDialog);
        }
      }
    }
  }
</script>

<style scoped lang="less">
  @import "~styles/index.less";
  @import "~styles/variable.less";

  .report-dialog-page {
    width: 100% !important;
    height: 100% !important;
    background: rgba(0, 0, 0, .5);
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 7;
    position: fixed;
  }

  .content {
    background: #FFFFFF;
    position: fixed;
    .btm(30);
    .left(20);
    .right(20);
    .b-radius(24);
    text-align: center;
    font-family: Gilroy-Medium;

    .item-action {
      width: 100%;
      //.lh(105);
      .h(71);
      .lh(45);
      .pt(34);
      .fs(32);
      font-weight: 600;
      color: #0B0B0B;
      text-align: center;
      margin: auto;
    }

    .item-action:not(.item-action:last-child)::after {
      width: 100%;
      content: '';
      display: inline-block;
      .h(1);
      background: #ebebeb;
    }

    .cancel-action {
      .h(88);
      .ml(30);
      .mr(30);
      .mb(30);
      .b-radius(49);
      background: #ededed;
      .fs(32);
      text-align: center;
      font-weight: 600;
      color: #B2B5B8;
      .lh(88);
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/widget/reportdialog.vue